var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6672 23.3333H8.40055C7.09377 23.3333 6.43988 23.3334 5.94076 23.079C5.50171 22.8553 5.14502 22.4983 4.92131 22.0593C4.66699 21.5602 4.66699 20.9068 4.66699 19.6V8.4C4.66699 7.09322 4.66699 6.43983 4.92131 5.9407C5.14501 5.50166 5.50171 5.14468 5.94076 4.92097C6.43988 4.66666 7.09376 4.66666 8.40055 4.66666H19.6006C20.9073 4.66666 21.5603 4.66666 22.0594 4.92097C22.4985 5.14468 22.8559 5.50166 23.0796 5.9407C23.3339 6.43983 23.3337 7.09321 23.3337 8.4V11.6667M22.167 22.1667L18.667 18.6667M15.7503 19.8333C13.4952 19.8333 11.667 18.0052 11.667 15.75C11.667 13.4948 13.4952 11.6667 15.7503 11.6667C18.0055 11.6667 19.8337 13.4948 19.8337 15.75C19.8337 18.0052 18.0055 19.8333 15.7503 19.8333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSearch);
export default __webpack_public_path__ + "static/media/note_search.457abfbf9234ff6daed4bde31752d426.svg";
export { ForwardRef as ReactComponent };